import { TextField } from '@mui/material';
import ErrorText from 'components/ErrorText/ErrorText';
import {
  Control,
  Controller,
  FieldErrors,
  FieldPath,
  FieldValues,
  PathValue,
} from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import WordCounter from '../WordCounter/WordCounter';

interface WordCounterFieldProps<TFormValues extends FieldValues> {
  name: FieldPath<TFormValues>;
  control: Control<TFormValues>;
  errors: FieldErrors<TFormValues>;
  label: string;
  maxLength: number;
  currentCount: number;
  onCountChange: (count: number) => void;
}

export default function WordCounterField<TFormValues extends FieldValues>({
  name,
  control,
  errors,
  label,
  maxLength,
  currentCount,
  onCountChange,
}: WordCounterFieldProps<TFormValues>) {
  const { t } = useTranslation();
  const error = errors[name];

  return (
    <>
      <Controller
        name={name}
        control={control}
        defaultValue={'' as PathValue<TFormValues, FieldPath<TFormValues>>}
        rules={{
          required: true,
          maxLength,
        }}
        render={({ field }) => (
          <TextField
            {...field}
            label={label}
            fullWidth
            error={!!error}
            helperText={error && t('formErrors.nameRequired')}
            onChange={(e) => {
              field.onChange(e);
              onCountChange(e.target.value.length);
            }}
          />
        )}
      />
      <WordCounter currentWordCount={currentCount} maxCount={maxLength} />
      {error && <ErrorText>{t('formErrors.nameRequired')}</ErrorText>}
    </>
  );
}
